export default "__VITE_ASSET__aef69d3e__"